import { useEffect, useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../hooks/useAuth";
import { useNotificationService } from "../../components/notification";
import { apiGetJobId } from "../../api/jobs";
import { useLocation } from "react-router-dom";
import { getUrlPathId } from "../../utils/url-id";
import {
  JobIdDetailsProps,
  defaultJobDetails,
} from "../../interface/job_board";
import JobBoardDetailsContent from "../../components/jobBoard/JobBoardDetailsContent";
import BackButton from "../../components/UIElements/BackButton";

const JobBoardDetails = () => {
  const isMedium = useResponsive("down", "md", "xl");
  const { showNotification } = useNotificationService();
  const { token } = useAuth();
  const [modal_status, setModal_status] = useState("");
  const location = useLocation();
  const jobId = getUrlPathId(location?.pathname);

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["jobDetails", jobId],
    queryFn: () => apiGetJobId({ jobId: jobId ?? "" }),
    enabled: !!jobId && !!token,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  useEffect(() => {
    if (isLoading || !data) return;

    if (isError) {
      showNotification("Fetch process failed", "error");
      return;
    }

    if (data?.status === "error" && "msg" in data) {
      showNotification(data?.msg ?? "", "error");
    } else if ("data" in data && data?.data?.data?.status) {
      setModal_status(data?.data?.data?.status);
    }
  }, [data, isError, isLoading]);

  const jobDetails: JobIdDetailsProps =
    data?.status === "error" || isError || !data
      ? defaultJobDetails
      : data.data.data;

  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <BackButton />
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: "#2F66F4",
              }}
            >
              View Job
            </Typography>
          </Stack>
        </Box>
      </Header>
      <JobBoardDetailsContent
        modalStatus={modal_status}
        setModalStatus={setModal_status}
        jobDetails={jobDetails}
        loading={isLoading}
        onUpdated={refetch}
      />
    </>
  );
};

export default JobBoardDetails;
